// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2uNU5","right":"Footer_right__2m8TS","buttons":"Footer_buttons__3s93h"};